import React from "react";
import { Link } from 'react-router-dom';
import './About.css'

const About = () => {
    return (
        <section id="about" className="health-text">
            <h2 className="section-title">HM Escola de Kickboxing</h2>
            <p>
                Somos um grupo dedicado de praticantes de kickboxing com o objetivo de formar campeões e cidadãos exemplares, unindo técnica, disciplina e valores fundamentais.
            </p>
            <p>
                A nossa essência vai muito além dos treinos e das competições. Aqui cultivamos um verdadeiro espírito de família, assente em valores como o civismo, o respeito e a humildade. Estes princípios são a base do nosso trabalho, tanto para quem procura alto rendimento no ringue como para quem procura bem-estar físico e psicológico.
            </p>
            <Link to="/About_us" className="btn-secondary">Conhece a nossa história</Link>
        </section>
    );
}

export default About;
